import { render, staticRenderFns } from "./cargaHorariaPraticaTable.vue?vue&type=template&id=04930e72"
import script from "./cargaHorariaPraticaTable.vue?vue&type=script&lang=js"
export * from "./cargaHorariaPraticaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports